import { useQuery } from "react-query"
import { searchPosts } from "../requests/search"

export function usePostSearch(query, page = 1, perPage = 5) {
  return useQuery(
    ["post_search", query, page, perPage],
    () => searchPosts(query, { page, per_page: perPage }),
    {
      keepPreviousData: true,
      enabled: query && query.length >= 2 ? true : false, // Only search if query is at least 2 characters
    },
  )
}

